import { useEffect, useState } from 'react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useRachelErrorReporter } from '../../../../hooks/useRachelErrorReporter';

const COPIED_RESET_MS = 1500;

export const useRachelCopyMessage = (text: string) => {
  const [isCopied, setIsCopied] = useState(false);
  const { reportRachelError } = useRachelErrorReporter();

  useEffect(() => {
    if (!isCopied) {
      return;
    }

    const timeout = setTimeout(() => setIsCopied(false), COPIED_RESET_MS);
    return () => clearTimeout(timeout);
  }, [isCopied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
    } catch (error) {
      setIsCopied(false);
      reportRachelError(error, LangEnum.RACHEL_MESSAGE_COPY_ERROR);
    }
  };

  return { isCopied, copy };
};
